import Link from 'next/link';
import PropTypes from 'prop-types';
import { useAppSelector } from '@/redux';
import { formatUrl, getHrefForCategLink } from '@/utils/linkUtils';
import styles from './GlossaryList.module.scss';

export const GlossaryList = ({ sublist }) => {
	const { storeConf } = useAppSelector(({ root }) => root);

	return (
		<>
			{sublist.length > 0 && (
				<ul className={styles.container}>
					{sublist?.map((elem, key) => (
						<li key={key}>
							<Link
								className={styles.link}
								href={getHrefForCategLink(elem.urlKeyword, elem._id, elem.isSpirit)}
								as={formatUrl(elem.urlKeyword, elem.isSpirit, storeConf)}
								passHref
								dangerouslySetInnerHTML={{ __html: elem.name }}
							/>
						</li>
					))}
				</ul>
			)}
		</>
	);
};

GlossaryList.propTypes = {
	sublist: PropTypes.array.isRequired,
};

export default GlossaryList;
